import { defineStore } from 'pinia'
import { httpHelper } from '@/utils/helper/http.helper'
import { httpCommApiAuthDlvyLogin } from '@/service/apis/comm/auth/dlvy-login.api'
import {
  httpSuppMoDlMrDlvyJoinRetrieveDlvyLoginInfo,
  httpSuppMoDlLgLoginRetrieveUserInfo
} from '@/service/apis/supp/mo/dl.api'

export const useDLLG01V101Store = defineStore({
  id: 'useDLLG01V101Store',
  actions: {
    async actionHttpCommApiAuthDlvyLogin(fdata) {
      try {
        const response = await httpHelper(httpCommApiAuthDlvyLogin, fdata)
        console.debug('httpCommApiAuthDlvyLogin response :', response)
        return response
      } catch (error) {
        console.debug('httpCommApiAuthDlvyLogin error :', error)
        return error.response.data
      }
    },
    async actionHttpSuppMoDlLgLoginRetrieveUserInfo(fdata) {
      try {
        const response = await httpHelper(httpSuppMoDlLgLoginRetrieveUserInfo, fdata)
        console.debug('httpSuppMoDlLgLoginRetrieveUserInfo response :', response)
        return response
      } catch (error) {
        console.debug('httpSuppMoDlLgLoginRetrieveUserInfo error :', error)
        return error.response.data
      }
    },
    async actionHttpSuppMoDlMrDlvyJoinRetrieveDlvyLoginInfo(fdata) {
      try {
        const response = await httpHelper(httpSuppMoDlMrDlvyJoinRetrieveDlvyLoginInfo, fdata)
        console.debug('httpSuppMoDlMrDlvyJoinRetrieveDlvyLoginInfo response :', response)
        return response
      } catch (error) {
        console.debug('httpSuppMoDlMrDlvyJoinRetrieveDlvyLoginInfo error :', error)
        return error.response.data
      }
    }
  }
})
